module.exports = __webpack_public_path__ + "static/media/icon-4.1daf3ca6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-4.png
// module id = 132
// module chunks = 0